import { ReactNode, useEffect, useState } from 'react';
import parse from 'html-react-parser';

import bemClassName from '../../utils/bem';

import './index.scss';
import Public from '../../API/Public';
import Loading from '../../UI/Loading';

const requisites = bemClassName('requisites');

const Requisites = () => {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  let parsedHTML;
  if (data) {
    parsedHTML = parse(data.content);
  }

  useEffect(() => {
    document.title = 'Реквизиты';
    setIsLoading(true);
    Public.getRequisites()
      .then((items) => {
        setData(items);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  return (
    <>
      {isLoading ? (
        <Loading externalClassName={requisites('loading')} />
      ) : (
        data && (
          <>
            <h2 className={requisites('title')}>{data.title}</h2>
            <div className={requisites('inner')}>{parsedHTML as ReactNode}</div>
          </>
        )
      )}
    </>
  );
};

export default Requisites;
